import Receive from './Receive';

export default Receive;
